module.exports = __webpack_public_path__ + "static/img/logo-2.db04220.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-2.jpg
// module id = QOLf
// module chunks = 59